<div class="view-selection-wrapper">
    <div class="view-selection-button-group-container">
        <mat-button-toggle-group aria-label="View selection" [(ngModel)]="selectedView" (change)="viewChanged($event)">
            <mat-button-toggle class="font-weight-bold" [value]="'budget'">Budget</mat-button-toggle>
            <mat-button-toggle class="font-weight-bold" [value]="'options'" [checked]="true">Options</mat-button-toggle>
        </mat-button-toggle-group>
    </div>
</div>

<div class="layout-card">
    <div [class]="selectedView === 'options' ? ('table-container') : ('hide')">
        <div class="header">
            <div class="d-flex flex-row justify-content-start">
                <p class="font-weight-bold my-2">{{selectedTimeValue}} ASSORTMENT MAP - SKU, UNITS AND VALUE</p>
            </div>

            <span class="d-flex justify-content-start align-items-center">
                 <nz-select
                     class="dropdown-selector"
                     nzPlaceHolder="Select department"
                     [(ngModel)]="selectedDepartmentId"
                     (ngModelChange)="departmentChanged()"
                 >
                    <nz-option [nzValue]="department.id" [nzLabel]="getShortId(department.id)" *ngFor="let department of availableDepartmentValues"></nz-option>
                </nz-select>

                 <nz-select
                     class="dropdown-selector"
                     nzPlaceHolder="Select sub department"
                     [(ngModel)]="selectedSubDepartmentId"
                     (ngModelChange)="subDepartmentChanged()"
                 >
                    <nz-option [nzValue]="subDepartment.id" [nzLabel]="getShortId(subDepartment.id)" *ngFor="let subDepartment of filteredSubDepartmentValues"></nz-option>
                </nz-select>

                 <nz-select
                     class="dropdown-selector"
                     nzPlaceHolder="Select category"
                     nzAllowClear="true"
                     [(ngModel)]="selectedCategoryId"
                     (ngModelChange)="categoryChanged()"
                 >
                    <nz-option [nzValue]="category.id" [nzLabel]="getShortId(category.id)" *ngFor="let category of filteredCategoryValues"></nz-option>
                </nz-select>

                <nz-select
                    class="dropdown-selector"
                    nzPlaceHolder="Select season"
                    [(ngModel)]="selectedTimeValue"
                    (ngModelChange)="filterChanged()"
                >
                    <nz-option [nzValue]="timeValue" [nzLabel]="timeValue" *ngFor="let timeValue of availableTimeValues"></nz-option>
                </nz-select>

                <nz-select
                    class="dropdown-selector"
                    nzPlaceHolder="Select attribute"
                    [(ngModel)]="selectedAttribute"
                    (ngModelChange)="filterChanged()"
                >
                    <nz-option [nzValue]="value" [nzLabel]="value" *ngFor="let value of availableAttributes"></nz-option>
                </nz-select>

                <button class="approve-btn" *ngIf="activeViewContext === 'planner'" (click)="save()">Save</button>
                <button class="approve-btn" *ngIf="activeViewContext === 'manager'" (click)="approve()">Approve</button>
            </span>
        </div>

        <div class="collapse-container">
            <nz-collapse nzAccordion [nzBordered]="false">
                <nz-collapse-panel [nzHeader]="'Yearly Options Table'" [nzActive]="true">
                    <div class="wrapper">
                        <div class="brand-name">
                            <p>{{ selectedAttributeView?.attribute_value }}</p>
                        </div>
                        <div class="content">
                            <div class="ly-wrapper">
                                <div class="type-label">LY</div>
                                <lynkd-pattern-ly-plan-table
                                    [columnGroups]="selectedAttributeView?.ly_table_data.columnGroups"
                                    [columns]="selectedAttributeView?.ly_table_data.columns"
                                    [data]="selectedAttributeView?.ly_table_data.filtered_data"
                                    [totals]="selectedAttributeView?.ly_table_data.totals"
                                    [loading]="loading"
                                ></lynkd-pattern-ly-plan-table>
                            </div>
                            <div class="ly-wrapper">
                                <div class="type-label">TY</div>
                                <lynkd-pattern-ty-plan-table
                                    [columnGroups]="selectedAttributeView?.ty_table_data.columnGroups"
                                    [columns]="selectedAttributeView?.ty_table_data.columns"
                                    [data]="selectedAttributeView?.ty_table_data.filtered_data"
                                    [selectedSeason]="selectedTimeValue"
                                    [totals]="selectedAttributeView?.ty_table_data.total"
                                    [selectedAttributeValue]="selectedAttribute"
                                    [loading]="loading"
                                    (state)="getTableState($event)"
                                ></lynkd-pattern-ty-plan-table>
                            </div>
                        </div>
                    </div>
                </nz-collapse-panel>
                <nz-collapse-panel [nzHeader]="'Monthly Options Table'">
                    <lynkd-pattern-options-monthly-table
                        [attributeValue]="selectedAttributeView?.attribute_value"
                        [timeValue]="selectedTimeValue"
                        [data]="monthlyOptionsData"
                        [loading]="loading"
                        (updateTyOptionsApproval)="handleMonthlyOptionsSkuUpdate($event)"
                    ></lynkd-pattern-options-monthly-table>
                </nz-collapse-panel>
            </nz-collapse>
        </div>
    </div>

    <div [class]="selectedView === 'budget' ? ('table-container') : ('hide')">
        <div class="header">
            <div class="d-flex flex-row justify-content-start">
                <p class="font-weight-bold my-2"></p>
            </div>
            <div class="d-flex justify-content-start align-items-center">
                <nz-select
                    class="dropdown-selector"
                    nzPlaceHolder="Select department"
                    [(ngModel)]="selectedDepartmentId"
                    (ngModelChange)="departmentChanged()"
                >
                    <nz-option [nzValue]="department.id" [nzLabel]="getShortId(department.id)" *ngFor="let department of availableDepartmentValues"></nz-option>
                </nz-select>

                <nz-select
                    class="dropdown-selector"
                    nzPlaceHolder="Select sub department"
                    [(ngModel)]="selectedSubDepartmentId"
                    (ngModelChange)="subDepartmentChanged()"
                >
                    <nz-option [nzValue]="subDepartment.id" [nzLabel]="getShortId(subDepartment.id)" *ngFor="let subDepartment of filteredSubDepartmentValues"></nz-option>
                </nz-select>

                <nz-select
                    class="dropdown-selector"
                    nzPlaceHolder="Select category"
                    [(ngModel)]="selectedCategoryId"
                    (ngModelChange)="categoryChanged()"
                >
                    <nz-option [nzValue]="category.id" [nzLabel]="getShortId(category.id)" *ngFor="let category of filteredCategoryValues"></nz-option>
                </nz-select>

                <nz-select
                    nzPlaceHolder="Select season"
                    [(ngModel)]="selectedTimeValue"
                    class="dropdown-selector"
                    (ngModelChange)="filterChanged()"
                >
                    <nz-option [nzValue]="timeValue" [nzLabel]="timeValue" *ngFor="let timeValue of availableTimeValues"></nz-option>
                </nz-select>

                <nz-select
                    nzPlaceHolder="Select attribute"
                    [(ngModel)]="selectedAttribute"
                    class="dropdown-selector"
                    (ngModelChange)="filterChanged()"
                >
                    <nz-option [nzValue]="value" [nzLabel]="value" *ngFor="let value of availableAttributes"></nz-option>
                </nz-select>
                <button class="approve-btn" *ngIf="activeViewContext === 'planner'" (click)="save()">Save</button>
                <!-- <button class="btn mr-2">Upload</button> -->
                <!-- <button class="btn" (click)="saveOptionsTable()">Save</button> -->
            </div>
        </div>
        <div>
            <lynkd-pattern-totals-table
                [tYOptionsApprovalData]="tYOptionsApprovalData"
                [timeValue]="selectedTimeValue"
                [attributeValue]="selectedAttribute"
                [availableAttributes]="availableAttributes"
                [loading]="loading"
                (state)="handleOptionsTableUpdate($event)"
            >
            </lynkd-pattern-totals-table>
        </div>
    </div>
</div>
